import { createHashHistory as history} from 'history';

export default history();
